import Carousel from './Component/Carousel';

// TODO: works inconsistent
if ([ 'complete', 'loaded', 'interactive' ]
    .filter(v => v === document.readyState).length > 0 && document.body) {
      new Carousel();
} else {
  document.addEventListener('DOMContentLoaded', () => {
    new Carousel();
  }, false);
}

// works but not practical
// window.setTimeout(() => {
//   new Carousel();
// }, 10000);



// WEBPACK FOOTER //
// ./~/fcse-cms/Resources/public/js/Frontend/index.js